'use client';

import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  useSidebar,
} from '@zond/ui';
import { Download } from 'lucide-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getLogo } from '../../../../utils/get-logo';
import { ClientDownloadOptions } from '../../../modules/downloads/client-download-options';

export const DownloadClientWidget: React.FC = () => {
  const { t } = useTranslation('navigation');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { state } = useSidebar();

  const isCollapsed = state === 'collapsed';

  // Content for collapsed sidebar
  const collapsedContent = (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="flex items-center justify-center p-2">
          <Button variant="ghost" size="icon" onClick={() => setIsDialogOpen(true)}>
            <Download className="h-4 w-4" />
          </Button>
        </div>
      </TooltipTrigger>
      <TooltipContent side="right" align="center">
        <div className="font-medium">{t('download.title')}</div>
      </TooltipContent>
    </Tooltip>
  );

  // Content for expanded sidebar - now just a button
  const expandedContent = (
    <div className="px-3 pb-3">
      <Button
        variant="outline"
        className="w-full text-muted-foreground hover:text-foreground"
        onClick={() => setIsDialogOpen(true)}
      >
        <div className="flex items-center justify-center gap-2">
          <Download className="h-4 w-4" />
          <span>{t('download.title')}</span>
        </div>
      </Button>
    </div>
  );

  return (
    <>
      {isCollapsed ? collapsedContent : expandedContent}

      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="sm:max-w-2xl">
          <DialogHeader>
            <DialogTitle className="text-center text-2xl font-bold bg-gradient-to-r from-primary/90 to-primary bg-clip-text text-transparent">
              {t('download.title')}
            </DialogTitle>
          </DialogHeader>

          <div className="flex justify-center items-center mb-6">
            <img
              src={getLogo()}
              alt="Logo"
              className="w-16 h-16 dark:border dark:border-border/20 dark:rounded-full"
            />
          </div>

          <p className="text-center text-muted-foreground mb-6">{t('download.subtitle')}</p>

          <ClientDownloadOptions />
        </DialogContent>
      </Dialog>
    </>
  );
};
